import React from "react";

/** Multi-region CDN — primary + backup with automatic failover. */
export default function CdnRegionsPanel({ cdn, regionsData, triggerFailover }) {
  return (
    <>
          {/* Multi-region CDN — primary/backup with failover */}
          <div className="border-t border-zinc-800 pt-4" data-testid="cdn-regions-section">
            <div className="flex items-baseline justify-between mb-2">
              <div>
                <div className="font-display font-bold">Multi-region CDN · primary + backup</div>
                <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500">
                  policy: {regionsData?.failover_policy || "auto"} · threshold {regionsData?.failover_threshold || 3} · active
                  <span className="text-emerald-400"> {regionsData?.active_region || "—"}</span>
                </div>
              </div>
            </div>
            <div className="space-y-1">
              {(regionsData?.regions || []).map((r) => {
                const stats = regionsData?.stats_last_hour?.[r.region] || { segments: 0, ok_ratio: 0 };
                const isActive = regionsData?.active_region === r.region;
                return (
                  <div
                    key={r.region}
                    data-testid={`region-row-${r.region}`}
                    className={`flex items-center gap-2 border rounded-sm px-2 py-1.5 font-mono text-[11px] ${
                      isActive ? "border-emerald-500/50 bg-emerald-500/5" : "border-zinc-800 bg-black/30"
                    }`}
                  >
                    <span className={`w-2 h-2 rounded-full ${r.healthy ? "bg-emerald-500" : "bg-red-500 animate-pulse"}`} />
                    <span className={`w-20 ${r.is_primary ? "text-red-400" : "text-zinc-400"}`}>
                      {r.is_primary ? "PRIMARY" : "BACKUP"}
                    </span>
                    <span className="w-24 text-zinc-100">{r.region}</span>
                    <span className="flex-1 text-zinc-500 truncate">
                      {r.origin_type}://{r.origin_bucket || "—"}
                    </span>
                    <span className="w-20 text-zinc-400">seg/1h {stats.segments}</span>
                    <span className={`w-16 ${stats.ok_ratio >= 0.98 ? "text-emerald-400" : "text-amber-400"}`}>
                      {(stats.ok_ratio * 100).toFixed(1)}% OK
                    </span>
                    <span className="w-16 text-zinc-500">
                      {r.consecutive_failures > 0 ? `${r.consecutive_failures} fails` : "healthy"}
                    </span>
                    {isActive ? (
                      <span className="text-[10px] uppercase tracking-widest text-emerald-400 border border-emerald-500/40 px-2 py-0.5 rounded-sm">ACTIVE</span>
                    ) : (
                      <button
                        onClick={() => triggerFailover(r.region)}
                        data-testid={`failover-btn-${r.region}`}
                        className="text-[10px] uppercase tracking-widest border border-amber-500/60 text-amber-400 px-2 py-0.5 rounded-sm hover:bg-amber-500/10"
                      >
                        Fail over
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

    </>
  );
}
